import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { TipoViaVariacion } from './TipoViaVariacion';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { Provincia } from '../Provincias/Provincia';
import { TipoVia } from '../TiposVia/TipoVia';
import ErrorDialog from '../utilities/ErrorDialog';

export interface ITipoViaVariacionNewProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
}

export interface ITipoViaVariacionNewState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    tiposVia: TipoVia[];
    openErroDialog: boolean;
}

export default class TipoViaVariacionNew extends React.Component<ITipoViaVariacionNewProps, ITipoViaVariacionNewState> {
    _tipoViaVaracion: TipoViaVariacion = new TipoViaVariacion();
    
    public constructor(props: ITipoViaVariacionNewProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            tiposVia: [],
            openErroDialog: false
        }
    }

    componentDidMount(): void {
        this.GetTiposVia();
    }

    componentWillReceiveProps(nextProps: Readonly<ITipoViaVariacionNewProps>, nextContext: any): void {
        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Nuevo tipo de vía
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl required fullWidth variant="standard">
                                <InputLabel id="labelComunidadAutonoma">Seleccione un tipo de vía</InputLabel>
                                <Select label="Seleccione un tipo de vía" labelId='labelComunidadAutonoma' onChange={(event: SelectChangeEvent) => {
                                    this._tipoViaVaracion.tipoVia = event.target.value;
                                }}>
                                    {
                                        this.state.tiposVia.map((value: TipoVia, index: number) => {
                                            return (
                                                <MenuItem value={value.nombre}>
                                                    {
                                                        value.nombre
                                                    }
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Nombre' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._tipoViaVaracion.nombre = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Save.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Save() {
        if (this._tipoViaVaracion.nombre == '' || 
            this._tipoViaVaracion.nombre == null ||
            this._tipoViaVaracion.tipoVia == '' || 
            this._tipoViaVaracion.tipoVia == null
        ) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/tipoviavariaciones`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._tipoViaVaracion),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._tipoViaVaracion = new TipoViaVariacion();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._tipoViaVaracion = new TipoViaVariacion();
        });
    }

    private GetTiposVia(): void {
        let url = `${Common.END_POINT}/masters/tiposVia`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    tiposVia: response
                }
            );
        })
    }
}